export const BRAND_NAME = 'SureFood';

export const ROLES = {
  superadmin: 'SUPERADMIN',
  employee: 'EMPLOYEE',
  meal_planner: 'MEAL PLANNER',
  company_admin: 'COMPANY ADMIN',
  restaurant_admin: 'RESTAURANT ADMIN',
};

export const ORDER_STATUS = {
  Created: { received: true },
  Received: { received: true },
  Placed: { received: true },
  'Out for delivery': { ready: true },
  Delivered: { delivered: true },
};

export const ORDER_STATUS_ENUM = {
  placed: 'Placed',
  out_for_delivery: 'Out for delivery',
  cancelled: 'Cancelled',
  delivered: 'Delivered',
};

export const MEAL_TYPES = {
  veg: 'VEGETERIAN',
  nonVeg: 'NON VEGETERIAN',
  vegan: 'VEGAN',
};

export const PAYMENT_STATUS = {
  received: 'received',
  pending: 'pending',
  paid: 'paid',
};

export const MOBILE_NUMBER_REGEX = /^\d{10}$/;

export const SUBSIDY_TYPES = [
  {
    name: 'flat',
    formattedName: 'Flat',
  },
  {
    name: 'percentage',
    formattedName: 'Percentage',
  },
  {
    name: 'mixed_min',
    formattedName: 'Mix',
  },
];

export const GST_NUMBER_REGEX = new RegExp(
  '^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}(?=([A-Z0-9]{1}))\\1(?:)Z+[A-Z0-9]{1}$',
);
export const LOCALES = {
  en: {
    email: {
      required: "Email can't be left blank",
      invalidFormat: 'Invalid email format',
    },
    old_password: {
      required: "Existing Password can't be left blank",
    },
    password: {
      required: "Password can't be left blank",
      mismatch: "Passwords doesn't match",
    },
    confirm_password: {
      required: "Confirm password can't be left blank",
    },
    name: {
      required: "Name can't be left blank",
    },
    contactNumber: { required: "Mobile Number can't be left blank" },
    mobile_number: {
      required: "Mobile Number can't be left blank",
      numberFormat: 'Invalid mobile number',
    },
    phone_number: {
      required: "Phone Number can't be left blank",
      number: 'Phone Number must be a number',
    },
    invite_code: {
      required: "Invite code can't be left blank",
    },
    employeeId: {
      required: "Employee Id can't be left blank",
    },
    gst_number: {
      required: "GST number can't be left blank",
      format: 'Invalid GST number',
    },
    max_order_limit_amount: {
      required: "Max Order Limit can't be left blank",
    },
    subsidy: {
      required: "Subsidy can't be left blank",
      number: 'Subsidy must be a number',
      percentage: 'Subsidy percentage must not be more than 100',
    },
    subsidy_type: {
      required: "Subsidy Type can't be left blank",
    },
    logo_url: {
      required: "logo can't be left blank.",
    },
    rating: {
      number: 'Rating must be a number',
      max: 'Rating must be less than 5',
    },
    cuisines: {
      required: 'Please select atleast one cuisine',
    },
    address: {
      landmark: {
        required: "Landmark can't be left blank",
      },
      locality: {
        required: "Locality can't be left blank",
      },
      city: {
        required: "City can't be left blank",
      },
      state: {
        required: "State can't be left blank",
      },
      country: {
        required: "Country can't be left blank",
      },
      postal_code: {
        required: "Postal Code can't be left blank",
        number: 'Postal code must be a number',
      },
      latitude: {
        required: "Latitude can't be left blank",
        number: 'Latitude must be a number',
      },
      longitude: {
        required: "Longitude can't be left blank",
        number: 'Longitude must be a number',
      },
    },
    meal_schedule: {
      meals: {
        required: 'Select atleast one meal for the selected date',
      },
    },
  },
};
